import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section class="developers-about">
      <Helmet title="About" />
      <nav>
        <Link to="/">Home</Link>
        <span> | </span>
        About
        <span> | </span>
        <a href="mailto:adamzerner@protonmail.com">Contact</a>
        <span> | </span>
        <a href="https://www.buymeacoffee.com/adamzerner">Buy Me A Coffee</a>
      </nav>
      <p>
        <em>
          Note: This project has been shut down. See{" "}
          <a href="https://adamzerner.bearblog.dev/reflections-on-connect-developers/">
            this blog
          </a>{" "}
          post.
        </em>
      </p>
      <h1>About</h1>
      <p>
        In the ancestral environment, you were only able to socialize with the
        handful of people in your tribe. Then throughout history, your options
        grew. Tribes turned into towns, which turned into cities. And then when
        phones were invented, you became able to talk to almost anyone in the
        world.
      </p>
      <p>
        That is really cool. Previously Alice felt isolated in her small town.
        Now she can connect with people across the world who share her interest
        in Russian literature.
      </p>
      <p>
        Unfortunately, doing so isn't as easy as I made it sound. How does Alice
        actually find the people scattered around the globe who share her
        interests? Having a phone doesn't help if you don't have anyone to call.
      </p>
      <p>
        In theory, the internet should help a lot with this problem. You can
        have people submit their interests, run some code to figure out who has
        similar interests, and then get them in touch with each other. But in
        practice, it doesn't really feel like that's happened. I can't think of
        many people I know who have had meaningful relationships develop due to
        the internet. Instead, of having a human connection over a video call,
        The Internet prefers that you keep scrolling through your news feed.
      </p>
      <p>I want to call bullshit here. That is not how things should work.</p>
      <p>
        I doubt that this app will solve the problem outright, but it is a
        starting point, and hopefully it will help.
      </p>
      <h3>Ok cool. So… how exactly does this app work?</h3>
      <p>
        Good question. It's pretty simple really. Just answer as many questions
        as you'd like on the home page, fill in the stuff at the bottom, and
        click submit.
      </p>
      <p>
        Then you will receive an email connecting you to other developers who
        had answers most similar to yours. From there, you guys can set up an
        introductory video call and take it from there. Zoom, Signal, Google
        Meet, it's up to you.
      </p>
      <h3>But this app is just for programmers.</h3>
      <p>
        True. I do have a vision for something bigger, but I think it{" "}
        <a href="https://platformthinkinglabs.com/">makes sense</a> to start
        small, and programmers seem like a good audience to start with.
      </p>
      <h3>What do you have against doom scrolling?</h3>
      <p>
        Check out the book{" "}
        <a href="https://www.calnewport.com/books/digital-minimalism/">
          Digital Minimalism
        </a>{" "}
        and the{" "}
        <a href="https://www.humanetech.com/">Center for Humane Technology</a>.
      </p>
      <h3>Why does video chatting count as "real" connection?</h3>
      <p>
        There is a lot of research on how socializing is really great for both
        your health and your happiness.
      </p>
      <p>
        I want to be honest, it's not like I'm aware of randomized controlled
        trials showing that video chatting "counts" for this. It's just a hunch.
        It's also a lot easier to find like-minded people when geographic
        proximity isn't a requirement.
      </p>
      <h3>Have you heard of CSS before?</h3>
      <p>
        Yes, I have. But I was inspired by Justin Jackson's essay,{" "}
        <a href="https://justinjackson.ca/words.html">Words</a>, and that
        aesthetic felt appropriate here. His point is that the content of a web
        page is what really matters, and people have gotten side-tracked by
        fancy designs.
      </p>
      <p>
        Similarly, I feel that connecting people should be the heart of social
        networks, but we have gotten side-tracked by things like news feeds.
        This app isn't going to get side-tracked by that stuff. It's goal is to
        help you connect with people, and then get out of your way.
      </p>
    </section>
  );
};

export default About;
